/* IBM Confidential‌ - OCO Source Materials‌ - (C) COPYRIGHT IBM CORP. 2020-2024 - The source code for this program is not published or otherwise‌ divested of its trade secrets, irrespective of what has been‌ deposited with the U.S. Copyright Office. */

import React, { Component } from "react";
import UserAvatar from 'react-avatar';
import {
  Button,
  Card
} from "carbon-addons-iot-react";
import "../nav/NavMain.scss";
import "./UserProfile.scss";
import { AppMsg, NavConfig } from "../utils";
import ChangePasswordModal from "../changePassword/ChangePasswordModal";
import ChangePasswordNotification from "../changePassword/ChangePasswordNotification";
import { ChangePasswordService } from "../services/ChangePasswordService";
import { isSSO } from "../utils/UserSession";

const size = 'SMALLWIDE';
const COMPANY_LEVEL_PROJECT_ID = 1;

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showChangePasswordModal: false,
      isPasswordChangeSuccess: false,
    };
    this.contextProps = NavConfig.getNavConfigData();
    this.userProfile = this.contextProps.userProfile;
    this.passwordRules = {};
    this.isSSO = isSSO();
    this.customPasswordRules = [];
  }

  componentDidMount() {
    this._getChangePasswordRule();
  }

  _getChangePasswordRule() {
    if (Object.keys(this.passwordRules).length === 0) {
      Promise.all([
        ChangePasswordService.initPasswordRules(),
        ChangePasswordService.initCustomPasswordRules(this.props.username),
      ])
        .then(([passwordRules, customPasswordRules]) => {
          this.passwordRules = JSON.parse(passwordRules);
          this.customPasswordRules = customPasswordRules;
        })
        .catch((error) => {
          console.error("Error initializing password rules:", error);
        });
    }
  }

  //Set the User Profile Icon default/specific user image
  _setUserImage(userImage,userFullName){
 
    if(userImage){
      let path = this.props.tririgaContextUrl + '/getCompanyFile.jsp?fileLoc=' + userImage
      return(<UserAvatar size="32" src={`${path}`}  round={true} description="Icon"></UserAvatar>)
      }
    else{
      let customName = this._userIconName(userFullName);
      return(<UserAvatar className="style-usericon" name={customName} fgColor="#000000" size="32" textSizeRatio={1.75} color="white"  round={true} description="Icon"></UserAvatar>)
          }
  }

  //If the User Full Name has more than two words customize it so as to get appropriate initials for default user icon
  _userIconName(userFullName){
    let fullNameArray = userFullName.split(' ');
    let name = fullNameArray[0] + " " + fullNameArray[fullNameArray.length -1];
    return name;
  }

  _openUserProfile() {

    //First close user actions menu.
    this.props.closeUserActionsMenu();

    //Check for unsaved changes.
    if (this.props.unsavedDataService.isDataSaveNeeded(
          this.props.hierarchyListItemHandler.handleValidMenuItem(
            this.props.hierarchyListItemHandler.getListItemIdByName("sysMyProfile")))) {
      return;
    }
    
    let isProjectContext = this.props.currentProjectId > COMPANY_LEVEL_PROJECT_ID;

    this.props.handleNavFrameSourceForSubPage(this._handleMyProfileSrc(isProjectContext), "sysMyProfile"); 
  }

  _openChangePasswordModalFromEnterKey = (event) => {
    if (event.keyCode === 13) {
      this._openChangePasswordModal();
    }
  };

  _handleMyProfileSrc(isProjectContext) {
    let myProfileSrc = '/html/en/default/platform/mainpagepopout/mainpagepopout.jsp#name=sysMyProfile';
    if (isProjectContext) {
      myProfileSrc = myProfileSrc + '&project=' + this.props.currentProjectId;
    }
    return myProfileSrc;
  }

  //Handle enter key click
  _openUserProfileFromEnterKey(event) {
    //keyCode 13 is the enter key
    if (event.keyCode === 13) {
      this._openUserProfile();
    }
  }

  _openChangePasswordModal = () => {
    this.setState({
      showChangePasswordModal: true,
    });
  };

  _showPasswordChangedSuccessfully = () => {
    this.setState({
      isPasswordChangeSuccess: true,
      showChangePasswordModal: false,
    });
  };

  _handleCloseButton = () => {
    this.setState({
      showChangePasswordModal: false,
    });
  };

  _handleNotificationCloseButton = () => {
    this.setState({
      isPasswordChangeSuccess: false,
    });
  }

  render() {
    const { isPasswordChangeSuccess, showChangePasswordModal } = this.state;
    return (
      <div>
        <Card
          title={AppMsg.getMessage(AppMsg.USER_PROFILE)}
          id="user-profile"
          size={size}
          isLoading={false}
          isEmpty={false}
          isEditable={false}
          isExpanded={false}
          children={childSize => (
          <div className="user-profile-container">
            <div className="userProfileContent">
          <span className='icon'>{this._setUserImage(this.userProfile.userImage,this.userProfile.userFullName)}</span>
                <span className='text'><div className='full-name'>{this.userProfile.userFullName}</div><div className='email'>{this.userProfile.userEmail}</div></span>                
            </div>
            {this.contextProps.isShowPreferencesLink ?
            <div id='manageAccountDiv' className="userManageAccount">
              <Button kind="secondary" size="small" onClick={() => {this._openUserProfile()}} 
                        onKeyDown={(event) => {this._openUserProfileFromEnterKey(event)}}>
                {AppMsg.getMessage(AppMsg.USER_MANAGE)}
              </Button>
            </div>
            : null}
              {!this.isSSO && !this.contextProps.isOAuthUser && (
                <div id="changePasswordDiv" className="changePassword">
                  <Button
                    kind="secondary"
                    size="small"
                    onClick={() => {
                      this._openChangePasswordModal();
                    }}
                    onKeyDown={(event) => {
                      this._openChangePasswordModalFromEnterKey(event);
                    }}
                  >
                    {AppMsg.getMessage(AppMsg.CHANGE_PASSWORD)}
                  </Button>
                </div>
              )}
            </div>
          )}
        />
        {showChangePasswordModal && !this.isSSO && !this.contextProps.isOAuthUser && (
          <ChangePasswordModal
            passwordRules={this.passwordRules}
            customPasswordRules={this.customPasswordRules}
            username={this.props.username}
            showPasswordChangedSuccessfully={
              this._showPasswordChangedSuccessfully
            }
            handleCloseButton={this._handleCloseButton}
          />
        )}
        {isPasswordChangeSuccess &&
          !this.isSSO && (
            <ChangePasswordNotification
              dir={this.props.dir}
              handleNotificationCloseButton={
                this._handleNotificationCloseButton
              }
            />
          )}
      </div>
    );
  }
}

export default UserProfile;
